export const getCurrentFieldValue = (details, edits, fieldName) => {
  if (edits[fieldName] !== undefined) {
    return edits[fieldName];
  }
  if (details) {
    return details[fieldName];
  }
  return null;
};
